import PageLoader from '@/compoments/PageLoader'
import { useGetDispatcherCalendarQuery } from '@/services/dispatcher/dispather'

import 'react-datepicker/dist/react-datepicker.css'

import type {
    CalendarEvent,
    CalendarResource,
} from '@/compoments/features/Calendar'
import Calendar from '@/compoments/features/Calendar'
import { getMediaUrl, getStartAndEndOfDay } from '@/utils/helpers'

import { useState } from 'react'

const today = new Date()

const ResourceCalendar = () => {
    const [query, setQuery] = useState(getStartAndEndOfDay(today))
    const { data: response, isLoading } = useGetDispatcherCalendarQuery({
        query,
    })

    if (isLoading) {
        return <PageLoader style={{ height: 250 }} />
    }
    const data = response?.data

    if (!data?.length) {
        return null
    }

    const resources: CalendarResource[] = data.map(res => ({
        id: String(res.id),
        extendedProps: {
            fullName: res.fullName,
            photo: getMediaUrl(res.photo),
        },
    }))
    const events: CalendarEvent[] = data
        .map(item =>
            item.userAssignments.map(user => ({
                ...user,
                resourceId: item.id,
            })),
        )
        .flat()
        .map(res => ({
            id: String(res.id),
            start: res.order.startTime,
            end: res.order.endTime,
            resourceId: String(res.resourceId),
            extendedProps: {
                title: res.order.service?.name,
                note: res.order.service.description,
                status: res.order.status,
            },
        }))

    return (
        <Calendar
            resources={resources}
            events={events}
            setDateRage={setQuery}
        />
    )
}

export default ResourceCalendar
